"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BetreuerUebertragParent = function () {
  function BetreuerUebertragParent() {}
  BetreuerUebertragParent.STATUS_OFFEN = 'O';
  BetreuerUebertragParent.STATUS_ERLEDIGT = 'E';
  BetreuerUebertragParent.STATUS_FEHLER = 'F';
  BetreuerUebertragParent.STATUS_ANGELEGT = 'A';
  return BetreuerUebertragParent;
}();
exports.BetreuerUebertragParent = BetreuerUebertragParent;